import StatWidget from "./StatWidget";

export function StatsPanel({ books = [] }) {
  const total = books.length;
  const tbr = books.filter((b) => b.status === "tbr").length;
  const reading = books.filter((b) => b.status === "reading").length;
  const finished = books.filter((b) => b.status === "finished").length;

  const avgRating =
    books.filter((b) => b.rating > 0).reduce((sum, b) => sum + b.rating, 0) /
      Math.max(1, books.filter((b) => b.rating > 0).length) || 0;

  return (
    <section
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 16,
        background: "#1e293b",
        padding: 16,
        borderRadius: 16,
        border: "1px solid #334155",
        color: "#fff",
        marginTop: 16,
      }}
    >
      <StatWidget label="Total" value={total} accent="#38bdf8" />
      <StatWidget label="To Read" value={tbr} accent="#6366f1" />
      <StatWidget label="Reading" value={reading} accent="#22c55e" />
      <StatWidget label="Finished" value={finished} accent="#facc15" />
      <StatWidget
        label="Avg Rating"
        value={avgRating.toFixed(1)}
        accent="#f472b6"
      />
    </section>
  );
}
